import { useAppSelector } from '../data/store';
import { getSelectedTab } from '../domain/mobile-top-menu-provider';
import { useEffect } from 'react';
import { useAppDispatch } from '../data/store';
import { rootActions } from '../../account/data/store';
import { isAuthenticated } from '../../../membership/dal/data-provider';
import Preloader from '../../../../ui/svg/common/preloader';
import LoggedOutTab from './logged-out-tab';
import TabSection from './tab-section';
import { IsAuthReferrer } from '../../../membership/enums/is-auth-referrer';

const TabContent = () => {

    const dispatch = useAppDispatch();

    const isLoading = useAppSelector(store => store.root.isLoading);
    const data = useAppSelector(store => store.root.data);
    const isLoggedIn = useAppSelector(store => store.root.isLoggedIn);

    const selectedTabId = useAppSelector(store => store.root.selectedTabId);
    const selectedTab = getSelectedTab(data, selectedTabId);
    const hasMembership = selectedTab && !!selectedTab.hasMembership;
    const showLoggedOutTab = !!hasMembership && !isLoggedIn;

    useEffect(() => {
        if(!hasMembership) return;

        (async () => {
            dispatch(rootActions.main({
                isLoading: true,
            }));

            const response = await isAuthenticated(IsAuthReferrer.SiteHeader);

            if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData){
                dispatch(rootActions.main({
                    isLoggedIn: false,
                    userName: '',
                    isLoading: false,
                }));
                return;
            }

            const isUserAuthenticated: boolean = response.data.relatedData.isUserAuthenticated;
            if(isUserAuthenticated){
                dispatch(rootActions.main({
                    isLoggedIn: isUserAuthenticated,
                    userName: response.data.relatedData.userName ?? '',
                    isLoading: false,
                }));
            }
            else{
                dispatch(rootActions.main({
                    isLoggedIn: false,
                    userName: '',
                    isLoading: false,
                }));
            }
        })();
    }, [dispatch, selectedTab, hasMembership]);

    return (
        <div className="flex-1 mt-3 ml-6 mr-10 text-lg text-gray-400 overflow-auto" style={{
            paddingBottom: '100px',
        }}>
            {
                selectedTab &&
                <>
                    {
                        isLoading &&
                        <div className="flex justify-center">
                            <Preloader width="25px" height="25px" color="#4f4f4f" />
                        </div>
                    }

                    {
                        !isLoading && !showLoggedOutTab && selectedTab.sections.map((section, si) => {
                            return (
                                <TabSection
                                    key={ section.id }
                                    section={ section }
                                    isLastSection={ selectedTab.sections.length - 1 === si }
                                    hasMembership={ !!hasMembership }
                                />
                            )
                        })
                    }

                    {
                        !isLoading && showLoggedOutTab && <LoggedOutTab />
                    }
                </>
            }
        </div>
    )
};

export default TabContent;